import { ONBOARDING_URL, REDIRECT_SOURCES, SOURCE_PARAM_KEY } from "../../Constants/config";

/**
 * Waits for the specified number of milliseconds.
 * @param {number} ms - Milliseconds to wait
 * @returns {Promise<void>}
 */
export const wait = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

// Utility to merge refs (supports both ref objects and ref callbacks)
export const assignRefs =
  (...refs) =>
    (node) => {
      refs.forEach((ref) => {
        if (typeof ref === "function") {
          ref(node);
        } else if (ref && typeof ref === "object") {
          ref.current = node;
        }
      });
    };

export function createOnboardingAppUrl({
  path = '',
  additionalParams = {},
  source = REDIRECT_SOURCES.ADMIN,
  baseUrl = ONBOARDING_URL,
  appendSource = false,
} = {}) {
  try {
    // Construct full URL with optional path appended
    const url = new URL(path, baseUrl);

    // Append or override existing query params from additionalParams
    Object.entries(additionalParams).forEach(function ([key, value]) {
      url.searchParams.set(key, value);
    });

    // Always set source param
    if (appendSource) {
      url.searchParams.set(SOURCE_PARAM_KEY, source);
    }

    return url.toString();
  } catch (error) {
    // Fallback for relative/invalid URLs: manually build query string
    const params = Object.assign({}, additionalParams);
    params[SOURCE_PARAM_KEY] = source;

    const queryString = new URLSearchParams(params).toString();
    const separator = path.includes('?') ? '&' : '?';
    return baseUrl + path + separator + queryString;
  }
}